// day progress bar for dashboard list view
import React from 'react';
import '../styling/progress-bar.scss';

function ProgressBar({ currentDay, totalDays, onDayClick }) {
  return (
    <div className="progress-bar-container">
      <h2 className="progress-title">Day on Trip</h2>
      <div className="progress-bar-wrapper">
        <div className="steps">
          {Array.from({ length: totalDays }, (_, index) => (
            <div
              key={index}
              className={`step ${index + 1 === currentDay ? 'active' : ''}`}
              onClick={() => onDayClick(index + 1)}
            >
              <span className="step-number">{index + 1}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ProgressBar;
